import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Sticky from 'Components/Sticky';
import { ReactComponent as DownloadIcon } from 'Icons/download-new.svg';
import { ReactComponent as UploadIcon } from 'Icons/upload.svg';
import { ReactComponent as RawMaterial } from 'Icons/rawmaterial.svg';
import { ReactComponent as PStatus } from 'Icons/productionstatus.svg';
import { ReactComponent as Action } from 'Icons/action.svg';
import { ReactComponent as Edit } from 'Icons/edit.svg';
import { ReactComponent as Delete } from 'Icons/delete.svg';
import { ReactComponent as History } from 'Icons/history.svg';
import { ReactComponent as Calender } from 'Icons/calender.svg';
import SidePanel from "./SidePanel";
import Classnames from 'classnames';
import CreatePO from 'Components/SupplierPO/CreateOrder';
import SupplierOrderScreen from 'Components/SupplierPO/CreateOrder/supplierOrderScreen';
import RawMaterialStatus from "Components/SupplierPO/rawMaterialStatus";
import ProductionStatus from "Components/SupplierPO/productionStatus";
import { isDesmetSupplier, isSupplier } from "Utils/index";
import { getUser } from "Utils/storage";
import Overview from './Overview';
import {
    GET_ALL_PO,
    CREATE_PO,
    GET_PO_DROPDOWN_LISTS,
    DOWNLOAD_PO_TEMPLATE,
    UPLOAD_PO_DETAILS,
    GET_PART_DETAILS,
    GET_RAW_MATERIALS_OR_PRODUCTION_STATUS,
    UPLOAD_DOCUMENT,
    SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
    UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
    ACCEPT_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS,
    CANCEL_PO,
    GET_PO_DATA_BY_ID,
    UPDATE_PO,
    TOAST_ERROR,
    GET_PO_HISTORY,
    GET_PO_STATUS_COUNT,
    GET_PO_LIST,
    DOWNLOAD_UPLOADED_FILE,
    GET_SUPPLIER_ITEM_MASTER
} from 'Constants/actionConstants';
import ActionBlurLoader from "Components/ActionLoader/LoaderWithBlur";
import Upload from "Components/Upload/index";
import Moment from 'moment';
import OutsideClickHandler from "react-outside-click-handler";
import RenderPaginationButtons from "Components/EXIMCargoTracking/pagination";
import ReactTooltip from 'react-tooltip';
import HistoryPopup from "Components/SupplierPO/historyPopUp";
import Tab from "Components/Tabs/Tab";
import Tabs from "Components/Tabs/index";
import RawMaterialTable from "Components/SupplierPO/rawMaterialTable";
import ProductionTable from "Components/SupplierPO/productionTable";


const tabs = [
    // {label: 'New Orders', id: 2},
    // {label: 'Raw Material Approval', id: 3},
    {label: 'In Progress', id: 4},
    // {label: 'Production Approval', id: 5},
    {label: 'Completed', id: 6},
    {label: 'Draft', id: 1},
    {label: 'Cancelled', id: 99}
];

const desmetTabs = [
    // {label: 'New Orders', id: 2},
    // {label: 'Raw Material Approval', id: 3},
    {label: 'In Progress', id: 4},
    // {label: 'Production Approval', id: 5},
    {label: 'Completed', id: 6},
    {label: 'Cancelled', id: 99}
];

const subTabs = [
    {value: 'Approval', id: 1},
    {value: 'Rejected', id: 2}
]

const tableHeader = [
    'Project Id',
    'PO Number',
    'Item Number',
    'Item Net Weight (KG)',
    'Supplier',
    'Order Acknowledge Number',
    'Quantity',
    'Drawing Number',
    'Drawing Rev Number',
    'Hold Days',
    'PO Creation Date',
    'PO Delivery Date',
    'Proposed Delivery Date',
    'Material Status',
    'Production Status',
    'Free Issue'
]

const rawMaterialsObj = {
    product_type: '',
    product_description: '',
    product_grade: '',
    required_quantity: '',
    expected_date: null,
    uploaded_doc: '',
    is_approval_required: '',
    remarks: ''
}

const productionStatueObj = {
    process: '',
    start_date: null,
    completion_date: null,
    production_status: '',
    uploaded_doc: '',
    is_approval_required: '',
    remarks: ''
}


class SupplierPO extends Component {
    constructor(props) {
        super(props);
        const { menuType = 2 } = (props.match || {}).params;
        this.state = {
            selectedTab: +menuType,
            activeStatusTab: 2,
            search: '',
            selectedPO: '',
            offset: 0,
            limit: 10,
            subTab: '',
            poIdsList: [],
            poCountData: {},
            poNumberList: [],
            supplierList: [],
            poNumber: ''
        }
    }

    componentDidMount() {
        if(this.state.selectedTab == 2) {
            this.getAllPO('isFirst');
            this.getDropDownLists();
            this.getSupplierItemMaster();
        } else {
            this.getPOStatusCount();
            this.getPOList();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            if(this.state.selectedTab == 2) {
                this.getAllPO('isFirst');
                this.getDropDownLists();
                this.getSupplierItemMaster();
            } else {
                this.getPOStatusCount();
                this.getPOList();
            }
        }
      }

    getDropDownLists = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_PO_DROPDOWN_LISTS
        });
    }

    getSupplierItemMaster = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_SUPPLIER_ITEM_MASTER,
            params: { companyId: getUser().companyId }
        });
    }

    getAllPO = (val) => {
        const { dispatch } = this.props;
        const {
            activeStatusTab,
            offset,
            search,
            limit,
            subTab
        } = this.state;
        const params = {
            type: activeStatusTab,
            offset,
            limit,
            userType: isDesmetSupplier() ? 2 : 1
        }
        if(search) {
            params['search'] = search;
        }
        dispatch({
            type: GET_ALL_PO,
            params,
            activeStatusTab,
            subTab,
            onSuccess: (data) => {
                if(data.length > 0) {
                    this.setState({
                        selectedPO: data[0]
                    })
                }
            }
        });
    }

    onClickSideBar = (option) => {
        if(option.id == 3) {
            location.href = '/contracting/generic/supplierDashboard';
            return;
        }
        this.setState({
            selectedTab: option.id,
            fromDate: null,
            toDate: null,
            poIdsList: [],
            poNumberList: [],
            supplierList: [],
            poSearch: null,
            poNumber: null,   
            supplier: null,  
            poCountData: {}
        }, () => {
            const { history } = this.props;
            const { selectedTab } = this.state;
            history.push(`/contracting/generic/orders/${selectedTab}`);
        });
    }

    getPOStatusCount = () => {
        const { dispatch } = this.props;
        const { fromDate, toDate, poSearch, poNumber, supplier } = this.state;
        const queryParams = {
            fromDate,
            toDate
        };
        if(poNumber) {
            queryParams.poNumber = poNumber;
        }
        if(poSearch) {
            queryParams.search = poSearch;
        }
        if(supplier) {
            queryParams.supplilerName = supplier;
        }
        const onSuccess = (data) => {
            this.setState({
                poCountData: data || {}
            });
        };
        dispatch({
            type: GET_PO_STATUS_COUNT,
            queryParams,
            onSuccess
        });
    }

    getPOList = () => {
        const { dispatch } = this.props;
        const onSuccess = (data) => {
            const poIds = (data.projectIdList || []).map(el => {
                return { 
                    label: el,
                    value: el
            }}); 
            const poNumbers = (data.poNumberList || []).map(el => {
                return { 
                    label: el,
                    value: el
            }})
            const suppliers = (data.supplierList || []).map(el => {
                return {
                    label: el,
                    value: el
                }
            })
            this.setState({
                poIdsList: poIds || [],
                poNumberList: poNumbers || [],
                supplierList: suppliers || []
            });
        };
        dispatch({
            type: GET_PO_LIST,
            onSuccess
        })
    }

    onChangeSearch = (e) => {
        this.setState({
            search: e.target.value
        }, () => {
            const { search } = this.state;
            if(search.length > 2 || search == '') {
                this.getAllPO();
            }
        });
    }

    createNewOrder = (data, onClearPO) => {
        const { dispatch } = this.props;
        const onSuccess = () => {
            if(onClearPO) {
                onClearPO();
            }
            this.onOpenCreateOrder();
            this.getAllPO();
            if(data.po_id) {
                this.setState({
                    isEdit: false,
                    editData: ''
                });
            }
        }
        if(data.po_id) {
            dispatch({
                type: UPDATE_PO,
                data,
                onSuccess
            })
        } else {
            dispatch({
                type: CREATE_PO,
                data,
                onSuccess,
            });
        }
    }

    onOpenCreateOrder = (status) => {
        this.setState(prevState => {
            const newState = {
                createNewOrder: !prevState.createNewOrder,
                activeStatusTab: status || prevState.activeStatusTab
            };
            return newState;
        });
    }

    openRawMaterialStatus = (e, partData) => {
        if(e) {
            e.stopPropagation();
        }
        this.setState(prevState => {
            return {
            rawMaterialStatusModalOpen : !prevState.rawMaterialStatusModalOpen
            }
        }, () => {
            if(this.state.rawMaterialStatusModalOpen) {
                this.fetchRawMaterialsOrProductionStatus(1, partData);
            }
        });
    }

    openProductionStatus = (e, partData) => {
        if(e) {
            e.stopPropagation();
        }
        this.setState(prevState => {
            return {
                productionStatusModalOpen : !prevState.productionStatusModalOpen
            }
        }, () => {
            if(this.state.productionStatusModalOpen) {
                this.fetchRawMaterialsOrProductionStatus(2, partData);
            }
        });
    }

    onClickTab = (id) => {
        this.setState({
            activeStatusTab: id,
            subTab: '',
            selectedPO: {}
        }, this.getAllPO);
    }

    downloadTemplate = () => {
        const { dispatch } = this.props;
        dispatch({
            type: DOWNLOAD_PO_TEMPLATE
        });
    }

    onUploadDocument = (file) => {
        const { dispatch } = this.props;
        const formData = new FormData();
        formData.append("file", file);
        dispatch({
            type: UPLOAD_PO_DETAILS,
            payload: formData,
            onSuccess: this.getAllPO
        });
    }

    fetchRawMaterialsOrProductionStatus = (type, partData) => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            payload: {
                type,
                partNumber: partData.part_number,
                partId: partData.po_part_id
            },
            onSuccess: (data) => {
                if(type === 1) {
                    this.setState({
                        rawMaterials: data.length > 0 ? data : [{...rawMaterialsObj}],
                        rPartData: partData || {}
                    });
                } else {
                    this.setState({
                        productionStatus: data.length > 0 ? data : [{...productionStatueObj}],
                        rPartData: partData || {}
                    })
                }
                
            }
        })
    }

    // getPartDetails = (e, data) => {
    //     if(e) {
    //         e.stopPropagation();
    //     }
    //     if(this.state.activeStatusTab == 99) {
    //         return;
    //     }
    //     if(this.state.activeStatusTab == 1) {
    //         this.getPOData(data);
    //     } else {
    //         const { dispatch } = this.props;
    //         const { activeStatusTab, subTab } = this.state;
    //         const params = {
    //             poId: data.po_id
    //         }
    //         if([3, 5].includes(activeStatusTab) && subTab) {
    //             params['type'] = subTab
    //         }
    //         dispatch({
    //             type: GET_PART_DETAILS,
    //             params
    //         });
    //         this.setState({
    //             selectedPO: data
    //         });
    //     }
    // }

    getPOData = (data, isApprove) => {
        const { dispatch } = this.props;
        dispatch({
            // type: GET_PO_DATA_BY_ID,
            type: GET_PART_DETAILS,
            params: {
                poId: data.po_id,
                poPartId: ((data.partDetails || {}).po_part_id) || (data || {}).po_part_id
            },
            onSuccess: (data) => {
                this.setState({
                    editedData: data || {},
                    isEdit: true,
                    actionId: ''
                });
                if(!isApprove) {
                    this.onOpenCreateOrder();
                }
            }
        })
    }

    onAddRmRequirement = () => {
        const { rawMaterials } = this.state;
        rawMaterials.push({...rawMaterialsObj});
        this.setState({
            rawMaterials
        });
    }

    onChangeRawMaterial = (e, index) => {
        const { rawMaterials } = this.state;
        const { name, value } = e.target;
        rawMaterials[index][name] = ['required_quantity'].includes(name) && value ? Number(value) : value;
        this.setState({
            rawMaterials
        });
    }

    onChangeRawMaterialsDate = (date, name, index) => {
        const { rawMaterials } = this.state;
        rawMaterials[index][name] = date.valueOf();
        this.setState({
            rawMaterials
        });
    }

    onSelectRawMaterial = (option, index, name, id) => {
        const { rawMaterials } = this.state;
        rawMaterials[index][name] = option.value;
        rawMaterials[index][id] = option.id;
        this.setState({
            rawMaterials
        });
    }

    onUploadDocumentFile = (file, index, type) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            noSaveUpload: true,
            onSuccess: (data) => { 
                if(type === 1) {
                    const { rawMaterials } = this.state;
                    rawMaterials[index].uploaded_doc = data;
                    this.setState({
                        rawMaterials
                    });
                } else {
                    const { productionStatus } = this.state;
                    productionStatus[index].uploaded_doc = data;
                    this.setState({
                        productionStatus
                    });
                }
            }
        })
    }

    downloadUploadedFile = (fileName) => {
        const { dispatch } =  this.props;
        dispatch({
           type: DOWNLOAD_UPLOADED_FILE,
           param: {
              fileName
           }
        });
    }

    onChangeStatusRawMaterial = (e, index) => {
        const { rawMaterials } = this.state;
        const { checked } = e.target;
        rawMaterials[index]['is_approval_required'] = checked;
        this.setState({
            rawMaterials
        });
    }

    onSaveRawMaterials = (partData) => {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data: {
                type: 1,
                raw_material: partData.rawMaterials,
                part_number: partData.part_number,
                po_id: partData.po_id,
                po_part_id: partData.po_part_id
            },
            onSuccess: () => {
                // this.openRawMaterialStatus('', partData);
                // this.getAllPO();
            }
        })
    }

    onUpdateRawMaterial = (rawMaterial, partData) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data: {
                type: 1,
                raw_material: rawMaterial,
                raw_material_id: rawMaterial.raw_material_id,
                part_number: partData.part_number,
                po_id: partData.po_id,
                po_part_id: partData.po_part_id
            },
            onSuccess: () => {
                this.setState({
                    editId: ''
                });
                this.openRawMaterialStatus('' , partData);
            }
        });
    }

    updateNextProcess = () => {
        const { productionStatus } = this.state;
        productionStatus.push({
            ...productionStatueObj
        });
        this.setState({
            productionStatus
        });
    }

    onSelectProcessStatus = (option, index, name, id) => {
        const { productionStatus } = this.state;
        productionStatus[index][name] = option.value; 
        productionStatus[index][id] = option.id;
        this.setState({
            productionStatus
        });
    }

    onChangeProductionStatusDates = (date, name, index) => {
        const { productionStatus } = this.state;
        productionStatus[index][name] = date.valueOf();
        this.setState({
            productionStatus
        });
    }

    onChangeProcessStatus = (e, index) => {
        const { productionStatus } = this.state;
        const { checked } = e.target;
        productionStatus[index]['is_approval_required'] = checked;
        this.setState({
            productionStatus
        });
    }

    onChangeProcessInput = (e, index) => {
        const { productionStatus } = this.state;
        const { name, value } = e.target;
        productionStatus[index][name] = value;
        this.setState({
            productionStatus
        });
    }

    onClickEdit = (id) => {
        const { editId } = this.state;
        this.setState({
            editId: id
        });
    }

    onClickApproveOrReject = (type, isAccept, lineItem, partData, remarks) => {
        const { dispatch } = this.props;
        const data = {
            type,
            is_accept: isAccept,
            part_number: partData.part_number,
            po_id: partData.po_id,
            po_part_id: partData.po_part_id,
            rejected_remarks: remarks
        }
        if(type == 1)  {
            data['raw_material_id'] = lineItem.raw_material_id;
        }
        if(type == 2) {
            data['production_status_id'] = lineItem.production_status_id;
        }
        dispatch({
            type: ACCEPT_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS,
            data,
            onSuccess: () => {
                // if(type === 1) {
                //     this.openRawMaterialStatus('', partData);
                // } else if(type === 2) {
                //     this.openProductionStatus('', partData);
                // }
                this.getPOData(partData, 'true')
            }
        })
    }

    onClickAction = (e, id) => {
        e.stopPropagation();
        this.setState({
            actionId: id
        });
    }

    onDeletePO = (e, po) => {
        e.stopPropagation();
        const { dispatch } = this.props;
        dispatch({
            type: CANCEL_PO,
            data: {
                po_id: po.po_id,
                po_part_id: (po.partDetails || {}).po_part_id
            },
            onSuccess: () => {
                this.getAllPO();
                this.setState({
                    actionId: ''
                });
            }
        })
    }

    editData = (e, data) => {
        e.stopPropagation();
        this.getPOData(data);
    }

    goToPage = (pageNumber) => {
        const { limit } = this.state;
        this.setState({
            offset: (pageNumber - 1) * limit
        }, () => {
            this.getAllPO();
        })
    }

    throwError = (error) => {
        const { dispatch } = this.props;
        dispatch({
            type: TOAST_ERROR,
            message: error
        });
    }

    onClickViewHistory =(e, poData) => {
        e.stopPropagation();
        const { dispatch } = this.props;
        dispatch({
            type: GET_PO_HISTORY,
            data: {
                poId: poData.po_id,
                poPartId: ((poData.partDetails || {}).po_part_id)
            },
            onSuccess: (result) => {
                this.setState({
                    historyData: result || [],
                    poData: poData,
                    actionId: ''
                });
                this.onhandleHistoryPopup();
            }
        });
    }

    onhandleHistoryPopup = () => {
        this.setState((prevState) => {
            return { 
                historyModalOpen: !prevState.historyModalOpen 
            }
        }, () => {
            if(!this.state.historyModalOpen) {
                this.setState({
                    historyData: [],
                    poData: ''
                })
            }
        })
    }

    onDeleteRawMaterials = (index) => {
        const { rawMaterials } = this.state;
        rawMaterials.splice(index, 1);
        this.setState({
            rawMaterials
        });
    }

    onDeleteProductionStatus = (index) => {
        const { productionStatus } = this.state;
        productionStatus.splice(index, 1);
        this.setState({
            productionStatus
        });
    }

    onClickMyOrders = () => {
        this.setState({
           createNewOrder: false,
           isEdit: false
        }, () => {
            this.getAllPO();
        });
    }

    selectSubTab = (id) => {
        this.setState({
            subTab: id
        }, () => {
            // this.getPartDetails('', this.state.selectedPO)
        })
    }

    onSelectDateRange = (from, to) => {
        this.setState({
            fromDate: from && from.valueOf() || null,
            toDate: to && to.valueOf() || null
        }, this.getPOStatusCount)
    }
    
    onSelectPONumber = (option = {}) => {
        this.setState({
            poNumber: option && option.value || ''
        }, this.getPOStatusCount)
    }

    onSelectPOList = (option) => {
        this.setState({
            poSearch: option && option.value || ''
        }, this.getPOStatusCount)
    }

    onSelectVendor = (option) => {
        this.setState({
            supplier: option && option.value || ''
        }, this.getPOStatusCount)
    }

    getHeaders = () => {
        const { activeStatusTab } = this.state;
        let headerList = [...tableHeader];

        if (isSupplier()) {
            headerList = headerList.filter(el => el !== 'Supplier');
        }

        if (activeStatusTab === 4) {
            const index = headerList.indexOf('Drawing Rev Number');
            if (index !== -1) {
                headerList.splice(index + 1, 0, 'Drawing Status');
            }
        } else {
            headerList = headerList.filter(el => !['Hold Days', 'PO Creation Date'].includes(el));
        }

        return headerList;
    };

    render() {
        const { selectedTab, activeStatusTab, search, selectedPO, createNewOrder, rawMaterialStatusModalOpen, productionStatusModalOpen, rawMaterials, rPartData, productionStatus, editId, actionId, isEdit, editedData, offset, limit, historyModalOpen, historyData, poData, subTab }  = this.state;
        const isSupplier = isDesmetSupplier();
        const { poDropdownLists, orderData, poStatusCount, loaderT1, partDetails, supplierItemMaster } = this.props;

        return (
            <Sticky>
                {loaderT1 && <ActionBlurLoader fixed={true}/>}
                <div className={'supplierPO'}>
                    {!createNewOrder && <SidePanel selectedTab={selectedTab} onClickTab={this.onClickSideBar}/>}
                    <div className={Classnames("rightPanel", {
                        'createNew': createNewOrder
                    })}>
                        {selectedTab == 2 ?
                        <>
                        {createNewOrder ? <>
                            {((isEdit && !isSupplier) || ['6', 6].includes(activeStatusTab)) ? 
                                <SupplierOrderScreen 
                                    onClickMyOrders={this.onClickMyOrders}
                                    editedData={editedData}
                                    onClickApproveOrReject={this.onClickApproveOrReject}
                                    downloadUploadedFile={this.downloadUploadedFile}
                                />
                            :
                            <CreatePO
                                onCreate={this.createNewOrder}
                                poDropdownLists={poDropdownLists}
                                onOpenCreateOrder={this.onOpenCreateOrder}
                                isEdit={isEdit}
                                editedData={editedData}
                                throwError={this.throwError}
                                onClickMyOrders={this.onClickMyOrders}
                                // onSaveRawMaterials={this.onSaveRawMaterials}
                                onSaveProductionStatus={this.onSaveProductionStatus}
                                activeStatusTab={activeStatusTab}
                                supplierItemMaster={supplierItemMaster}
                            />} </>:
                            <>
                                <div className="flex flex-between col-1">
                                    <div className="flex flex-middle">
                                            {((isSupplier ? tabs : desmetTabs) || []).map(el => <div className={Classnames("tabLists", {
                                                'activeTab': el.id == activeStatusTab
                                            })} onClick={() => this.onClickTab(el.id)}>{`${el.label} (${poStatusCount[el.id] || '0'})`}</div>)}
                                    </div>
                                </div>
                                <div className={'orderTable flex mt-20'}>
                                    <div className={'oTable mr-5 col-1'}>
                                        <div className="orderHeader flex pv-10 flex-middle ph-10 flex-between">
                                            <div className={'flex flex-middle'}>
                                                <div className="ml-20">Orders</div>
                                                <div>
                                                    <input 
                                                        placeholder={`Project Id / PO Number`} 
                                                        type="text" 
                                                        className="ml-20 wt-220 ht-38 search searchBorder"
                                                        value={search}
                                                        onChange={this.onChangeSearch}
                                                    />
                                                </div>
                                            </div>
                                            {/* {[3, 5].includes(activeStatusTab) && <div className={'wt-300 ml-5'}>
                                               <Tabs tabs={subTabs} selectTab={this.selectSubTab} activeTabId={subTab}/>
                                            </div>} */}
                                             {isSupplier && <div className={"fRight"}>
                                                <div className="actionButtons flex flex-middle ph-10">
                                                    <button className="divButton" onClick={this.downloadTemplate}><DownloadIcon className="mr-5"/> Download Template</button>
                                                    <Upload onChange={this.onUploadDocument}><button className="divButton ml-10"><UploadIcon className="mr-5"/> Upload Excel</button></Upload>
                                                    <button className="divButton ml-10 bgPrimary" onClick={() => this.onOpenCreateOrder(2)}>+ Create New Order</button>
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="poTable">
                                            <table cellSpacing={0} className={'col-1'}>
                                                <thead>
                                                    <tr>
                                                        {/* <th>Project ID</th>
                                                        <th>PO Number</th>
                                                        <th>Order Acknowledge Number</th>
                                                        <th>Advance Payment in %</th> */}
                                                        {(this.getHeaders() || []).map((el, index) => (<th key={index}>{el}</th>))}
                                                        {![99].includes(activeStatusTab) && <th>Action</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(orderData || []).map((el, index) => {
                                                        // const isPOActive = ((selectedPO && selectedPO.po_id) === el.po_id ? 'activePo' : '');
                                                        const isPOActive = '';
                                                        const partDetails = (el.partDetails || {});
                                                    return(
                                                        <tr key={index} 
                                                            onClick={(e) =>{ 
                                                                if(el.status == 99) {
                                                                    return;
                                                                }
                                                                if(el.status === 1) {
                                                                    this.getPOData(el)
                                                                } else if(!isSupplier || [6].includes(el.status)) {
                                                                    this.editData(e, el) 
                                                                }
                                                            }}
                                                        >
                                                            <td className={isPOActive}>{el.project_id}</td>
                                                            <td className={isPOActive}>{el.po_number}</td>
                                                            <td className={isPOActive}>{partDetails.part_number}</td>
                                                            <td className={isPOActive}>{partDetails.net_weight != null ? `${partDetails.net_weight}` : '-'}</td>
                                                            {!isSupplier && <td className={isPOActive}>{el.floated_by}</td>}
                                                            <td className={isPOActive}>{el.order_acknowledge_number}</td>
                                                            <td className={isPOActive}>{partDetails.quantity}</td>
                                                            <td className={isPOActive}>{partDetails.drawing_number || "-"}</td>
                                                            <td className={isPOActive}>{partDetails.drawing_revision || "-"}</td>
                                                            {[4].includes(activeStatusTab) && (
                                                                <td className={isPOActive}>
                                                                    {partDetails.drawing_status ? (
                                                                        <span style={{
                                                                            background: partDetails.drawing_status === 'With Holds' ? '#FFF3CD' : partDetails.drawing_status === 'Fully Approved' ? '#D4EDDA' : 'transparent',
                                                                            color: partDetails.drawing_status === 'With Holds' ? '#856404' : partDetails.drawing_status === 'Fully Approved' ? '#155724' : 'inherit',
                                                                            padding: '2px 8px',
                                                                            borderRadius: '4px',
                                                                            fontWeight: 500,
                                                                            whiteSpace: 'nowrap'
                                                                        }}>
                                                                            {partDetails.drawing_status}
                                                                        </span>
                                                                    ) : '-'}
                                                                </td>
                                                            )}
                                                            {[4].includes(activeStatusTab) && <td className={isPOActive}>{el.hold_days || "-"}</td>}
                                                            {[4].includes(activeStatusTab) && <td className={isPOActive}>{partDetails.created && Moment(partDetails.created).format('DD MMM, YYYY') || '-'}</td>}
                                                            <td className={isPOActive}>{partDetails.po_delivery_date && Moment(partDetails.po_delivery_date).format('DD MMM, YYYY') || '-'}</td>
                                                            <td className={isPOActive}>{partDetails.proposed_delivery_date && Moment(partDetails.proposed_delivery_date).format('DD MMM, YYYY') || '-'}</td>
                                                            <td className={isPOActive}>
                                                                <span style={{display: 'block'}}>{(partDetails.raw_material_approver_status || {}).ratio || '-'}</span>
                                                                <span style={{display: 'block'}}>{(partDetails.raw_material_approver_status || {}).percentage != null ? `${(partDetails.raw_material_approver_status || {}).percentage}%` : '-'}</span>
                                                            </td>

                                                            <td className={isPOActive}>
                                                                <span style={{display: 'block'}}>{(partDetails.production_approver_status || {}).ratio || '-'}</span>
                                                                <span style={{display: 'block'}}>{(partDetails.production_approver_status || {}).percentage != null ? `${(partDetails.production_approver_status || {}).percentage}%` : '-'}</span>
                                                            </td>
                                                            <td className={isPOActive}>
                                                                {partDetails.free_issue_status == null ? '-' : (
                                                                    <span style={{
                                                                        background: partDetails.free_issue_status ? '#FFF3CD' : '#D4EDDA',
                                                                        color: partDetails.free_issue_status ? '#856404' : '#155724',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '4px',
                                                                        fontWeight: 500,
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                        {partDetails.free_issue_status ? 'Yes' : 'No'}
                                                                    </span>
                                                                )}
                                                            </td>

                                                            {![99].includes(activeStatusTab) && <td className={`${isPOActive} pr`}>
                                                                <div className={'pa'} style={{'marginTop': '-6px', 'width': '4%'}}>
                                                                    <div className={'wt-50'}>
                                                                        <Action className="curP" onClick={(e) => this.onClickAction(e, ((el.partDetails|| {}).po_part_id))}/>
                                                                        {partDetails.errorMessage && <Fragment>
                                                                            <a data-tip='tooltip' data-for={`po-tooltip-${((el.partDetails || {}).po_part_id)}`}> <span className="tooltip-icon fBold" style={{'background': (el.partDetails|| {}).colorCode }}>R</span> </a>
                                                                            <ReactTooltip globalEventOff='click' id={`po-tooltip-${((el.partDetails || {}).po_part_id)}`} type="dark" effect="solid"> 
                                                                                <span> {partDetails.errorMessage || '-'} </span><br />
                                                                            </ReactTooltip>
                                                                        </Fragment>}
                                                                    </div>
                                                                    {((el.partDetails || {}).po_part_id) === actionId && 
                                                                        <div className={'actionPopup fRight pr fLeft pb-10 ph-10'}>
                                                                            {isSupplier && ![6, 99].includes(activeStatusTab) && <div className={'fs-14 pt-10 tLeft flex flex-middle'} onClick={(e) => this.editData(e, el)}><Edit className="wt-15 ht-15 mr-10"/>Edit Order Details</div>}
                                                                            <div className={'fs-14 pt-10 tLeft flex flex-middle'} onClick={(e) => this.onClickViewHistory(e, el)}><History className="wt-15 ht-15 mr-10"/>View history</div>
                                                                            {isSupplier && ![6, 99].includes(activeStatusTab) && <div className={'fs-14 pt-10 tLeft flex flex-middle'} onClick={(e) => this.onDeletePO(e, el)}><Delete className="wt-15 ht-15 mr-10"/>Delete</div>}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </td>}
                                                        </tr>
                                                    )})}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="box-shadow ht-40 bg-white flex flex-middle">
                                            <div className={'col-2 countStatus tCenter pl-50'}>
                                                {`Showing ${orderData.length > 0 ? offset + 1 : offset} to ${offset + (orderData.length)} of ${poStatusCount[activeStatusTab]} entries`}
                                            </div>
                                            <div className={'col-2 flex flex-right'}>
                                                <RenderPaginationButtons 
                                                    totalCount={poStatusCount[activeStatusTab]}
                                                    goToPage={this.goToPage}
                                                    offset={offset}
                                                    limit={limit}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-2 ml-5">
                                    {isSupplier && <div>
                                        <div className="actionButtons flex flex-middle ph-10">
                                            <button className="divButton" onClick={this.downloadTemplate}><DownloadIcon className="mr-5"/> Download Template</button>
                                            <Upload onChange={this.onUploadDocument}><button className="divButton ml-10"><UploadIcon className="mr-5"/> Upload Excel</button></Upload>
                                            <button className="divButton ml-10 bgPrimary" onClick={this.onOpenCreateOrder}>+ Create New Order</button>
                                        </div>
                                    </div>}
                                        <div className={'partDetails mt-10'}>
                                            <div className="orderHeader flex flex-between pv-10 flex-middle ph-10">
                                                <div className="ml-20">Part Details</div>
                                            </div>
                                            {(partDetails || []).map((partData, partIndex) => {
                                            return(
                                                <div className="partData mt-20 ml-15 mr-15">
                                                        <div className="fs-16 fSemibold">
                                                            <span>Part Number : </span><span style={{'color': '#597EF7'}}>{partData.part_number}</span> 
                                                            <span style={{'color': '#858991'}}> <b>|</b> Net Weight : {partData.net_weight}  Kg</span>
                                                        </div>
                                                        <div className="mt-15">
                                                            <div className={'flex flex-between'}>
                                                                <div className={'wt-300'}>
                                                                    <div className={'fs-12'} style={{'fontWeight': '400', 'color': '#30343C'}}>Quantity</div>
                                                                    <div className={'mt-5 fs-14'} style={{'fontWeight': '500',  'color': '#30343C'}}>{partData.quantity}</div>
                                                                </div>
                                                                <div className={'wt-300'}>
                                                                    <div className={'fs-12'} style={{'fontWeight': '400', 'color': '#30343C'}}>Drawing Rev <span className="br-10 ht-10 p-4" style={{background: '#28C76F33'}}>{partData.drawing_status}</span></div>
                                                                    <div className={'mt-5 fs-14'} style={{'fontWeight': '500',  'color': '#30343C'}}>{partData.drawing_revision}</div>
                                                                </div>
                                                                <div className={'wt-300'}>
                                                                    <div className={'fs-12'} style={{'fontWeight': '400', 'color': '#30343C'}}>PO Delivery on*</div>
                                                                    <div className={'mt-5 fs-14 flex flex-middle'} style={{'fontWeight': '500',  'color': '#30343C'}}><Calender className="wt-15 ht-15 mr-5"/>{partData.po_delivery_date && Moment(partData.po_delivery_date).format('DD MMM, YYYY')}</div>
                                                                </div>
                                                            </div>
                                                            <div className={'flex flex-between mt-15'}>
                                                                <div className={'wt-300'}>
                                                                    <div className={'fs-12'} style={{'fontWeight': '400', 'color': '#30343C'}}>Proposed Delivery on*</div>
                                                                    <div className={'mt-5 fs-14 flex flex-middle'} style={{'fontWeight': '500',  'color': '#30343C'}}><Calender className="wt-15 ht-15 mr-5"/>{partData.proposed_delivery_date && Moment(partData.proposed_delivery_date).format('DD MMM, YYYY')}</div>
                                                                </div>

                                                                <div className={'wt-300'}>
                                                                    <div className={'fs-12'} style={{'fontWeight': '400', 'color': '#30343C'}}>Material Status</div>
                                                                    <div className={'mt-5 fs-14 flex flex-middle'} style={{'fontWeight': '500',  'color': '#30343C'}}>
                                                                        {partData.rawMaterialList && <Fragment>
                                                                            <a data-tip='tooltip' data-for={`material-tooltip-${partData.part_number}`}><span className="tooltip-icon fBold">i</span> </a>
                                                                            <ReactTooltip globalEventOff='click' id={`material-tooltip-${partData.part_number}`} type="dark" effect="solid"> 
                                                                                <RawMaterialTable data={partData.rawMaterialList || []}/>
                                                                            </ReactTooltip>
                                                                        </Fragment>}
                                                                        <span className={'ml-5'}>{(partData.raw_material_approver_status || {}).ratio}</span>
                                                                    </div>
                                                                </div>
                                                                <div className={'wt-300'}>
                                                                <div className={'fs-12'} style={{'fontWeight': '400', 'color': '#30343C'}}>Production Status</div>
                                                                    <div className={'mt-5 fs-14 flex flex-middle'} style={{'fontWeight': '500',  'color': '#30343C'}}>
                                                                        {partData.production_status  && <Fragment>
                                                                            <a data-tip='tooltip' data-for={`production-tooltip-${partData.part_number}`}> <span className="tooltip-icon fBold">i</span></a>
                                                                            <ReactTooltip globalEventOff='click' id={`production-tooltip-${partData.part_number}`} type="dark" effect="solid"> 
                                                                            <ProductionTable data={partData.productionStatusList || []}/>
                                                                            </ReactTooltip>
                                                                        </Fragment>}
                                                                        <span className={"ml-5"}>{(partData.production_status || {}).ratio}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mt-15">
                                                            <div className={'flex flex-between'}>
                                                                <div>
                                                                    <div className={'fs-12'} style={{'fontWeight': '400', 'color': '#30343C'}}>Email I'd</div>
                                                                    <div className={'mt-5 fs-14'} style={{'fontWeight': '500',  'color': '#30343C'}}>
                                                                        {(selectedPO && selectedPO.email_ids || []).map((email, eIndex) => {
                                                                        return(<div>{`${email}${selectedPO.email_ids.length != (eIndex + 1) ? ' | ' : '' }`}</div>
                                                                        )})}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    {[2, 3, 4, 5, 6].includes(activeStatusTab) && <div className="mt-20">
                                                            <div className={'flex'}>
                                                                <button className="divButton" onClick={(e) => this.openRawMaterialStatus(e, partData)} style={{'color': (partData.raw_material_approver_status || {}).colorCode, 'borderColor':  (partData.raw_material_approver_status || {}).colorCode}}>
                                                                    <RawMaterialImg className="mr-5" color={(partData.raw_material_approver_status || {}).colorCode}/> Raw Material Status</button>
                                                                <button className={Classnames("divButton ml-20 flex flex-middle", {'disabled': !partData.production_status_enable})} onClick={(e) => this.openProductionStatus(e, partData)} disabled={!partData.production_status_enable} style={{'color': (partData.production_status || {}).colorCode, 'borderColor':  (partData.production_status || {}).colorCode}}>
                                                                    <ProductionStatusImg className="mr-5" color={(partData.production_status || {}).colorCode}/>Production Status</button>
                                                            </div>
                                                        </div>}
                                                </div>)})}
                                        </div>
                                    </div> */}
                                </div>
                            </>}
                        </> :
                        <Overview 
                            onSelectDateRange={this.onSelectDateRange}
                            onSelectPOList={this.onSelectPOList}
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            poIdsList={this.state.poIdsList}
                            poSearch={this.state.poSearch}
                            poCountData={this.state.poCountData}
                            poNumberList={this.state.poNumberList}
                            onSelectPONumber={this.onSelectPONumber}
                            supplierList={this.state.supplierList}
                            onSelectVendor={this.onSelectVendor}
                        />}
                    </div>
                    {
                        rawMaterialStatusModalOpen && 
                        <RawMaterialStatus 
                            isModalPopupOpen={rawMaterialStatusModalOpen}
                            handleModalPopupClose={this.openRawMaterialStatus}
                            rawMaterials={rawMaterials}
                            onAddRmRequirement={this.onAddRmRequirement}
                            poDropdownLists={poDropdownLists}
                            onChangeRawMaterial={this.onChangeRawMaterial}
                            onChangeRawMaterialsDate={this.onChangeRawMaterialsDate}
                            onSelectRawMaterial={this.onSelectRawMaterial}
                            onUploadDocument={this.onUploadDocumentFile}
                            onChangeStatusRawMaterial={this.onChangeStatusRawMaterial}
                            onSaveRawMaterials={this.onSaveRawMaterials}
                            downloadUploadedFile={this.downloadUploadedFile}
                            partData={rPartData || {}}
                            onUpdateRawMaterial={this.onUpdateRawMaterial}
                            onClickEdit={this.onClickEdit}
                            editId={editId}
                            onClickApproveOrReject={this.onClickApproveOrReject}
                            onDeleteRawMaterials={this.onDeleteRawMaterials}
                        />
                    }
                    {
                        productionStatusModalOpen && 
                        <ProductionStatus 
                            isModalPopupOpen={productionStatusModalOpen}
                            handleModalPopupClose={this.openProductionStatus}
                            data={productionStatus}
                            partData={rPartData || {}}
                            updateNextProcess={this.updateNextProcess}
                            poDropdownLists={poDropdownLists}
                            onSelectProcessStatus={this.onSelectProcessStatus}
                            onChangeProductionStatusDates={this.onChangeProductionStatusDates}
                            onUploadDocument={this.onUploadDocumentFile}
                            downloadUploadedFile={this.downloadUploadedFile}
                            onChangeProcessStatus={this.onChangeProcessStatus}
                            onChangeProcessInput={this.onChangeProcessInput}
                            onSaveProductionStatus={this.onSaveProductionStatus}
                            onUpdateProductionStatus={this.onUpdateProductionStatus}
                            onClickEdit={this.onClickEdit}
                            editId={editId}
                            onClickApproveOrReject={this.onClickApproveOrReject}
                            onDeleteProductionStatus={this.onDeleteProductionStatus}
                            activeStatusTab={activeStatusTab}
                        />
                    }
                    {historyModalOpen && 
                        <HistoryPopup
                            isModalPopupOpen={historyModalOpen}
                            handleModalPopupClose={this.onhandleHistoryPopup}
                            historyData={historyData}
                            poData={poData}
                         />
                    }
                </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ PODetails, common }) =>  {
    return {
        loaderT1: !!common.loaderT1,
        orderData: PODetails.ordersData || [],
        poDropdownLists: PODetails.poDropdownLists || {},
        poStatusCount: PODetails.poStatusCount || {},
        partDetails: PODetails.partDetails || [],
        supplierItemMaster: PODetails.supplierItemMaster || []
    }
}

export default connect(mapStateToProps, null)(SupplierPO);

const RawMaterialImg = (props) => {
    return (
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M2.66602 12C2.11046 12 1.63824 11.8055 1.24935 11.4166C0.86046 11.0277 0.666016 10.5555 0.666016 9.99996C0.666016 9.71107 0.721571 9.43607 0.832682 9.17496C0.943793 8.91385 1.11046 8.68885 1.33268 8.49996V5.33329H2.66602V1.33329H7.99935L11.1327 8.71663C11.1993 8.87218 11.2493 9.02774 11.2827 9.18329C11.316 9.33885 11.3327 9.49996 11.3327 9.66663C11.3327 10.3111 11.1049 10.8611 10.6493 11.3166C10.1938 11.7722 9.64379 12 8.99935 12C8.54379 12 8.12435 11.8805 7.74102 11.6416C7.35768 11.4027 7.07157 11.0777 6.88268 10.6666H4.54935C4.4049 11.0666 4.16046 11.3888 3.81602 11.6333C3.47157 11.8777 3.08824 12 2.66602 12ZM11.9993 11.3333V0.666626H13.3327V9.99996H15.3327V11.3333H11.9993ZM2.66602 10.6666C2.8549 10.6666 3.01324 10.6027 3.14102 10.475C3.26879 10.3472 3.33268 10.1888 3.33268 9.99996C3.33268 9.81107 3.26879 9.65274 3.14102 9.52496C3.01324 9.39718 2.8549 9.33329 2.66602 9.33329C2.47713 9.33329 2.31879 9.39718 2.19102 9.52496C2.06324 9.65274 1.99935 9.81107 1.99935 9.99996C1.99935 10.1888 2.06324 10.3472 2.19102 10.475C2.31879 10.6027 2.47713 10.6666 2.66602 10.6666ZM8.99935 10.6666C9.27713 10.6666 9.51324 10.5694 9.70768 10.375C9.90213 10.1805 9.99935 9.9444 9.99935 9.66663C9.99935 9.38885 9.90213 9.15274 9.70768 8.95829C9.51324 8.76385 9.27713 8.66663 8.99935 8.66663C8.72157 8.66663 8.48546 8.76385 8.29102 8.95829C8.09657 9.15274 7.99935 9.38885 7.99935 9.66663C7.99935 9.9444 8.09657 10.1805 8.29102 10.375C8.48546 10.5694 8.72157 10.6666 8.99935 10.6666ZM5.94935 7.33329H9.09935L7.11602 2.66663H3.99935V5.33329L5.94935 7.33329Z" fill={props.color || "#597EF7"}/>
        </svg>
    )
}

const ProductionStatusImg = (props) => {
    return (
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask 
          id="mask0_5509_4112" 
          maskUnits="userSpaceOnUse" 
          x="0" 
          y="0" 
          width="16" 
          height="17" 
          style={{ maskType: 'alpha' }}  // Corrected style as object
        >
          <rect y="0.0217896" width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5509_4112)">
          <path 
            d="M2.64909 14.0218V12.0218H4.71575L3.01576 6.45516C2.71576 6.28849 2.46853 6.04405 2.27409 5.72183C2.07964 5.3996 1.98242 5.05516 1.98242 4.68849C1.98242 4.13294 2.17687 3.66071 2.56576 3.27183C2.95464 2.88294 3.42687 2.68849 3.98242 2.68849C4.41576 2.68849 4.80187 2.81349 5.14076 3.06349C5.47964 3.31349 5.71576 3.63294 5.84909 4.02183H7.98242V3.35516C7.98242 3.16627 8.04631 3.00794 8.17409 2.88016C8.30187 2.75238 8.4602 2.68849 8.64909 2.68849C8.74909 2.68849 8.84631 2.71071 8.94075 2.75516C9.0352 2.7996 9.11576 2.86627 9.18242 2.95516L10.3158 1.88849C10.4158 1.78849 10.5352 1.7246 10.6741 1.69683C10.813 1.66905 10.9491 1.68849 11.0824 1.75516L13.6824 2.95516C13.8158 3.02183 13.9074 3.11905 13.9574 3.24683C14.0074 3.3746 14.0046 3.4996 13.9491 3.62183C13.8824 3.75516 13.7852 3.84127 13.6574 3.88016C13.5296 3.91905 13.4046 3.91071 13.2824 3.85516L10.8824 2.75516L9.31575 4.22183V5.15516L10.8824 6.58849L13.2824 5.48849C13.4046 5.43294 13.5324 5.42738 13.6658 5.47183C13.7991 5.51627 13.8935 5.5996 13.9491 5.72183C14.0158 5.85516 14.0213 5.98294 13.9658 6.10516C13.9102 6.22738 13.8158 6.32183 13.6824 6.38849L11.0824 7.62183C10.9491 7.68849 10.813 7.70794 10.6741 7.68016C10.5352 7.65238 10.4158 7.58849 10.3158 7.48849L9.18242 6.42183C9.11576 6.48849 9.0352 6.5496 8.94075 6.60516C8.84631 6.66071 8.74909 6.68849 8.64909 6.68849C8.4602 6.68849 8.30187 6.6246 8.17409 6.49683C8.04631 6.36905 7.98242 6.21071 7.98242 6.02183V5.35516H5.84909C5.81576 5.44405 5.77964 5.52738 5.74076 5.60516C5.70187 5.68294 5.64909 5.76627 5.58242 5.85516L8.91576 12.0218H11.3158V14.0218H2.64909ZM3.98242 5.35516C4.17131 5.35516 4.32964 5.29127 4.45742 5.16349C4.5852 5.03571 4.64909 4.87738 4.64909 4.68849C4.64909 4.4996 4.5852 4.34127 4.45742 4.21349C4.32964 4.08571 4.17131 4.02183 3.98242 4.02183C3.79353 4.02183 3.6352 4.08571 3.50742 4.21349C3.37964 4.34127 3.31576 4.4996 3.31576 4.68849C3.31576 4.87738 3.37964 5.03571 3.50742 5.16349C3.6352 5.29127 3.79353 5.35516 3.98242 5.35516Z" 
            fill={props.color || "#597EF7"}
          />
        </g>
      </svg>
    );
  };
  

